
const Form = (target) => {

  const method = {

    init: () => {
      method.checkIfFilled();
      method.treatDates();

      target.addEventListener("keyup", method.checkIfFilled);
      target.addEventListener("change", method.checkIfFilled);
    },

    checkIfFilled: () => {
      if (target.value.length > 0 && target.value !== "-1") {
        target.parentElement.parentElement.classList.add("fieldset--filled");
      } else {
        target.parentElement.parentElement.classList.remove("fieldset--filled");
      }
    },

    treatDates: () => {
      if (target.type === "date") {
        const input = target;
        input.type = "text";
        input.addEventListener("focus", () => {
          input.type = "date";
        });
        input.addEventListener("blur", () => {
          if (input.value.length < 1) input.type = "text";
        });
      }
    },
  };

  method.init();
};

export default Form;
